import React from 'react'
import { useFormik } from 'formik'
import isEqual from 'lodash/isEqual'
import * as yup from 'yup'

import TextInput from 'components/CommonUI/TextInput/TextInput'
import Button from 'components/CommonUI/Button/Button'
import { getIsFetchingUpdateSelector } from 'redux/reducers/devices'
import { useShallowEqualSelector } from 'custom-hooks'

let schema = yup.object().shape({
  name: yup
    .string('Panel name should be string')
    .trim("Panel name can't start or end the space character")
    .min(2, 'Panel name must be at least 2 characters')
    .max(128, 'Panel name must be at most 128 characters')
    .required('Panel name is a required field'),
  description: yup
    .string('Panel description should be string')
    .trim("Panel description can't start or end the space character")
    .min(4, 'Panel description must be at least 4 characters')
    .max(256, 'Panel description must be at most 256 characters'),
})

const ModalForm = ({ initialData, handleSubmittForm }) => {
  const isFetchingUpdate = useShallowEqualSelector(getIsFetchingUpdateSelector)

  const formik = useFormik({
    initialValues: {
      name: initialData.name, /// 128
      id: initialData.id,
      description: initialData.description, /// 256
    },
    validationSchema: schema,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: (values) => {
      handleSubmittForm(values)
    },
  })

  const disabledButton = isEqual(formik.values, initialData)

  return (
    <form onSubmit={formik.handleSubmit} className="modal_form_container">
      <TextInput
        label="Name"
        name="name"
        classNameContainer="form_input"
        value={formik.values.name}
        onChange={formik.handleChange}
        errorMessage={formik.touched.name && formik.errors.name}
      />
      <TextInput
        label="ID"
        name="id"
        disabled
        classNameContainer="form_input"
        value={formik.values.id}
        onChange={formik.handleChange}
        className=""
      />
      <TextInput
        label="Description"
        name="description"
        classNameContainer="form_input"
        value={formik.values.description}
        onChange={formik.handleChange}
        errorMessage={formik.touched.description && formik.errors.description}
      />
      <Button
        type="submit"
        disabled={disabledButton || isFetchingUpdate}
        fetchingIndicator={isFetchingUpdate}
      >
        Save changes
      </Button>
    </form>
  )
}

export default ModalForm
